import { BriefDossier, CaseDossier, Id, ZoneTypeEnum } from '../../types'

export enum DossierTypeEnum {
  Case = 'case', //ZoneTypeEnum.Case,
  Brief = 'brief', //ZoneTypeEnum.Brief,
}

export type DossierType = `${DossierTypeEnum}`

export interface Dossier {
  id: Id
  // type: DossierType
  type: 'case' | 'brief' //DossierTypeEnum
}

// unused:
export type AnyDossier = CaseDossier | BriefDossier
